/**
 * Playtest bridge (test-only): lets a harness start an exact match, advance
 * exact game time and read the state, instead of playing there in real time,
 * which runs in slow motion on a GPU-less machine. Contract:
 * ~/.claude/skills/game-playtest/references/bridge.md. Installed only with
 * `?playtest` in the URL (`?playtest=local` for two players, otherwise vs AI)
 * or under the dev server; normal play never calls it. Wired up in App.js.
 */

/**
 * Whether this page load exposes the bridge.
 *
 * @param {string} search location.search
 * @returns {boolean}
 */
export function playtestRequested(search) {
  return process.env.NODE_ENV === 'development' || new URLSearchParams(search).has('playtest');
}

/**
 * Which match the bridge's reset() starts: `?playtest=local`, else vs AI.
 *
 * @param {string} search location.search
 * @returns {'ai'|'local'}
 */
export function playtestMode(search) {
  return new URLSearchParams(search).get('playtest') === 'local' ? 'local' : 'ai';
}

/**
 * Publish the bridge on window.
 *
 * @param {{snapshot: Function, reset: Function, setSeed: Function, step: Function}} bridge
 * @returns {() => void} removes it again
 */
export function installPlaytestBridge(bridge) {
  window.__PLAYTEST__ = bridge;
  return () => {
    if (window.__PLAYTEST__ === bridge) delete window.__PLAYTEST__;
  };
}
